import styles from "../../styles/pages/admin.module.css";
import ChannelList from "../../components/ChannelList";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react-lite";
import { appStore } from "../../stores";
import adminService from "../../services/admin";
import { Chat } from "../../models/chat";
import AdminNav from "../../components/AdminNav";


function AdminChat() {
  const tg = window.Telegram.WebApp;
  const [chats, setChats] = useState([] as Chat[]);
  const [getChatsProcess, setGetChatsProcess] = useState(false);
  const [scope, setScope] = useState<"all" | "onlyActive">("all");
  const [loading, setLoading] = useState(false);
  const [processButtons, setProcessButtons] = useState([] as string[]);
  const navigate = useNavigate();

  const getChats = async () => {
    setGetChatsProcess(true);
    const response = await adminService.getChats(null, scope === "onlyActive" ? true : false);
    setGetChatsProcess(false);

    if (response.status === 200) {
      setChats(response.data.chats);
    } else {
      appStore.addError("При получении чатов произошла ошибка");
    };
  };

  const cancel = () => {
    tg.HapticFeedback.impactOccurred("heavy");
    navigate("/offers", { replace: true });
  };

  useEffect(() => {
    tg.BackButton.show();
    tg.BackButton.onClick(cancel);
    
    return () => {
      tg.BackButton.offClick(cancel);
      tg.BackButton.hide();
    };
  }, []);

  useEffect(() => {
    setChats([]);
    getChats();
  }, [scope]);

  const handleOpenChannel = async (chat: Chat) => {
    tg.HapticFeedback.impactOccurred("light");
    tg.openTelegramLink(chat.invite_link);
  };

  const handleChatButton = async (chat: Chat, type: "approve" | "decline") => {
    setProcessButtons(prev => [...prev, String(chat.id)]);
    
    const response = await adminService.updateChatState([chat.id], type === 'approve');

    if (response.status === 200) {
      setChats(prev =>
        prev.map(c =>
          c.id === chat.id ? { ...c, is_approved: type === 'approve' } : c
        )
      );
    } else {
      appStore.addError("При отправке статуса чата произошла ошибка");
    };

    setProcessButtons(prev => prev.filter(chatId => chatId !== String(chat.id)));
  };

  const switchScope = () => {
    tg.HapticFeedback.impactOccurred("light");
    setScope(prev => prev === "all" ? "onlyActive" : "all");
  };
  
  const bottomScroll = async () => {
    if (chats.length === 0)
      return;
    
    const lastOrder = chats[chats.length - 1];
    
    try {
      setLoading(true);
      const response = await adminService.getChats(lastOrder.id, scope === "onlyActive" ? true : false);
      
      if (response.status !== 200) {
        throw new Error();
      };
      
      setChats(c => [...c, ...response.data.chats]);
    } catch {
      appStore.addError("При получении чатов произошла ошибка");
    } finally {
      setLoading(false);
    };
  };

  return (
    <div className={styles.body}>
        <ChannelList
          bottomButtons={{[scope === "all" ? "Все чаты" : "С активными заказами"]: switchScope}}
          handleChannelButton={handleChatButton}
          handleChannelClick={handleOpenChannel}
          mode="adminChat"
          list={chats}
          nullMessage={getChatsProcess ? "Загрузка чатов..." : "Нет чатов"}
          processButtons={processButtons}
          scrollBottomCallback={bottomScroll}
          inline={false}
          loading={loading && chats.length > 0 ? true : false}
        />
        <AdminNav activePage={2}/>
    </div>
  );
}

export default observer(AdminChat);